export const formatWorkingHours = (workingHours) => {
    const formattedData = [];
  
    Object.entries(workingHours).forEach(([key, { slots, isWorkingDay }], index) => {
      if (isWorkingDay) {
        let startHour = null;
        let startMinute = null;
        let isCurrentSlotActive = false;  // Track if we're inside a working time slot
  
        // Traverse the slots string to identify intervals
        for (let i = 0; i < slots.length; i++) {
          const hour = Math.floor(i / 2);  // Calculate the hour
          const minute = (i % 2) * 30;    // Determine whether it's 00 or 30 minute interval
          const currentTime = `${hour.toString().padStart(2, "0")}:${minute === 0 ? "00" : "30"}`;
  
          if (slots[i] === "1" && !isCurrentSlotActive) {
            // We found a start of a working time
            startHour = hour;
            startMinute = minute;
            isCurrentSlotActive = true;
          } else if (slots[i] === "0" && isCurrentSlotActive) {
            // We found the end of a working time
            const endHour = hour;
            const endMinute = minute;
  
            // Add the time interval to the result array
            formattedData.push({
              day: index, // Day index starts from 0 (Sunday) to 6 (Saturday)
              from: `${startHour.toString().padStart(2, "0")}:${startMinute === 0 ? "00" : "30"}`,
              to: `${endHour.toString().padStart(2, "0")}:${endMinute === 0 ? "00" : "30"}`,
            });
  
            isCurrentSlotActive = false;
          }
        }
  
        // Handle case where the last interval is still active (i.e., day ends with a working period)
        if (isCurrentSlotActive) {
          const endHour = 23;  // End the last interval at 23:59 (end of the day)
          const endMinute = 30;
          formattedData.push({
            day: index,
            from: `${startHour.toString().padStart(2, "0")}:${startMinute === 0 ? "00" : "30"}`,
            to: `${endHour.toString().padStart(2, "0")}:${endMinute === 0 ? "00" : "30"}`,
          });
        }
      }
    });
  
    return formattedData;
  };